import {find} from '../helpers';

const fade = find('[data-swipe-fade]');
const multiview = find('[data-swipe-multiview]');
const ticker = find('[data-swipe-ticker]');
const classic = find('[data-swipe-classic]');
// const modalThumbs = find('[data-swipe-modal-thumbs]');

if (fade) {
    import('./fade');
}

if (multiview) {
    import('./multiview');
}

if (ticker) {
    import('./ticker');
}

if (classic) {
    import('./classic');
}

// if (modalThumbs) {
import('./modal-thumbs');
// }

import('./thumbs');
